/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore
import { Flyout } from '@els/els-react--flyout';
// @ts-ignore
import { Header } from '@els/els-react--header';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
// @ts-ignore
import { SkipLinks } from '@els/els-react--skip-links';
import { loginFlow } from '../../features/login/login-thunk';
import { AsyncStatus, hasSucceeded } from '../../constants/async-status';
import {
    selectAppConfigs,
    selectAppConfigsAsyncStatus,
} from '../../features/app-config/app-config-selector';
import {
    selectOriginalRedirectUrl,
    selectPOCValidAsyncStatus,
} from '../../features/login/login-selector';

const GeneralHeader = () => {
    const dispatch = useDispatch();
    const appConfigsAsyncStatus = useSelector(selectAppConfigsAsyncStatus);
    const appConfigs = useSelector(selectAppConfigs);
    const pocValidAsyncStatus = useSelector(selectPOCValidAsyncStatus);
    const originalRedirectUrl = useSelector(selectOriginalRedirectUrl);

    const onLoginHandler = () => {
        dispatch(loginFlow());
    };

    const SUPPORT_HUB_HOME_URL =
        hasSucceeded(appConfigsAsyncStatus) &&
        Object.keys(appConfigs).length > 0
            ? appConfigs.SUPPORT_HUB_HOME_URL
            : '';

    const SUPPORT_HUB_CONTACT_US_URL =
        hasSucceeded(appConfigsAsyncStatus) &&
        Object.keys(appConfigs).length > 0
            ? appConfigs.SUPPORT_HUB_CONTACT_US_URL
            : '';

    const onLogoClick = () => {
        let redirectUrl = window.location.origin;
        if (
            pocValidAsyncStatus === AsyncStatus.SUCCESS &&
            originalRedirectUrl
        ) {
            redirectUrl = originalRedirectUrl;
        }
        window.location.href = redirectUrl;
    };

    const onWordmarkClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.preventDefault();
        onLogoClick();
    };

    return (
        <Header
            className="general-header"
            id="Clinical-learning-hub-logo"
            wordmark={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <span className="general-header__app-name">
                    Clinical Learning Hub
                </span>
            }
            wordmarkLink={{
                href: window.location.origin,
                onClick: onWordmarkClick,
                'aria-label': 'Clinical Learning Hub home',
                id: 'clh-home-link',
            }}
            hideTreeAtMobile
        >
            <SkipLinks
                sections={[
                    {
                        id: 'header-content',
                        title: 'main content',
                    },
                ]}
                id="skip-link"
            />
            <nav className="general-header__general-nav">
                <ul className="general-header__general-nav__list">
                    <li className="general-header__general-nav__list-item">
                        <Flyout
                            flyout={
                                <ul>
                                    <li>
                                        <LinkElement
                                            href={SUPPORT_HUB_HOME_URL}
                                            target="_blank"
                                            id="header-content"
                                            tabIndex={0}
                                            iconSprite={
                                                Icon.Sprites.HELP_OUTLINE_CIRCLE
                                            }
                                            iconEmphasis
                                        >
                                            Support Hub
                                        </LinkElement>
                                    </li>
                                    <li>
                                        <LinkElement
                                            href={SUPPORT_HUB_CONTACT_US_URL}
                                            target="_blank"
                                            id="header-content"
                                            tabIndex={0}
                                            iconSprite={Icon.Sprites.EMAIL}
                                            iconEmphasis
                                        >
                                            Contact Us
                                        </LinkElement>
                                    </li>
                                </ul>
                            }
                            shouldCloseOnESC
                            placement="bottom-end"
                            theme="default"
                            pointerType="primary"
                        >
                            <Icon
                                a11y={{
                                    name: 'Settings icon',
                                    description:
                                        'denotes that this item is settings',
                                }}
                                id="header-content"
                                tabIndex={0}
                                aria-label="SUPPORT AND CONTACT US"
                                className="header-settings-icon"
                                sprite={Icon.Sprites.HELP_OUTLINE_CIRCLE}
                            />
                        </Flyout>
                    </li>
                    <li className="general-header__general-nav__list-item">
                        <button
                            type="submit"
                            onClick={onLoginHandler}
                            className="c-els-button"
                        >
                            Sign in
                        </button>
                    </li>
                </ul>
            </nav>
        </Header>
    );
};

export default GeneralHeader;
